import { useQuery } from '@tanstack/react-query';
import { workTicketApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Every work ticket raised against a job. */
export function useWorkTickets(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.workTickets.forJob(jobId ?? -1),
    queryFn: ({ signal }) =>
      workTicketApiClient.list(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    meta: { errorContext: 'work tickets' },
  });
}
